export const growthModels = [
    { id: 0, label: '- Select Model -' },
    { id: 1, label: 'Rapid Growth/Decline' },
    { id: 2, label: 'Most Likely' },
    { id: 3, label: 'Slow Growth' },
    { id: 4, label: 'Slow Growth/Decline' },
];
